<template>
  <div
    class="text-and-image container critical-component-clear"
    :class="[
      {
        'text-and-image--has-media': hasMedia,
      },
      `text-${settings.textAlignment}`,
    ]"
  >
    <div class="text-and-image__inner grid">
      <div
        v-if="!hasMedia"
        class="col xs-span"
        :class="[
          {
            'l1-6': settings.textAlignment === 'left',
            'l3-10': settings.textAlignment === 'center',
          },
        ]"
      >
        <heading-copy
          :classes="{
            copy: 'text-body-s-regular text-body-m-regular-desktop',
          }"
          :content="heading"
        />
      </div>

      <template
        v-else
      >
        <div
          v-if="settings.layout === 'media_right'"
          class="col xs-span l6"
        >
          <heading-copy
            :classes="{
              copy: 'text-body-s-regular text-body-m-regular-desktop',
            }"
            :content="heading"
          />
        </div>

        <div class="col xs-span l6">
          <div class="text-and-image__media stretched-link-container">
            <a
              v-if="heading.buttonUrl"
              class="stretched-link"
              :href="heading.buttonUrl"
              v-text="''"
            />

            <video-player
              v-if="settings.video"
              class="text-and-image__video"
              :attributes="settings.videoSettings"
              :intersection-observer="{
                enable: settings.videoSettings.autoplay,
              }"
              :image="settings.video.previewImage"
              :lazyload="settings.lazyload"
              :loaded-animation="settings.lazyload"
              :ratio="settings.ratio"
              sizes="(min-width: 1024px) 50vw, 100vw"
              :sources="settings.video.sources"
            />

            <responsive-image
              v-else
              class="text-and-image__image"
              :image="settings.image"
              :ratio="settings.ratio"
              :lazyload="settings.lazyload"
              :loaded-animation="settings.lazyload"
              sizes="(min-width: 1024px) 50vw, 100vw"
            />
          </div>
        </div>

        <div
          v-if="settings.layout === 'media_left'"
          class="col xs-span l6"
        >
          <heading-copy
            :classes="{
              copy: 'text-body-s-regular text-body-m-regular-desktop',
            }"
            :content="heading"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Text and image (text-and-image)
 * -----------------------------------------------------------------------------
 * Text and image side by side, with option to flip the layout.
 *
 * @param {Object} heading - Heading copy and settings.
 * @param {Object} settings - Section settings.
 *
 */
import HeadingCopy from '~async/heading-copy/heading-copy'
import ResponsiveImage from '~global/images/responsive-image'
import VideoPlayer from '~async/video-player/video-player'

export default {
  name: 'TextAndImage',

  components: {
    HeadingCopy,
    ResponsiveImage,
    VideoPlayer,
  },

  props: {
    heading: {
      type: Object,
      default: () => ({}),
    },

    settings: {
      type: Object,
      default: () => ({
        image: false,
        layout: 'image_right',
        ratio: '1:1',
        textAlignment: 'center',
        video: false,
        videoSettings: {},
      }),
    },
  },

  computed: {

    /**
     * Returns true if image or video exists
     * @returns {Boolean}
     */
    hasMedia() {
      return this.settings.image || this.settings.video
    },
  },
}
</script>

<style lang="scss">
@import './text-and-image';
</style>
